module.exports = __webpack_public_path__ + "static/login-heart-f7f299db9963f7c544966ca1e8563c63.png";